module.exports = __webpack_public_path__ + "img/twitter-x-gray.6e47af4c.svg";